import { BasicDepartmentResourceModel, DepartmentIdModel } from '@/modules/department/models/department-resource.model'
import { BasicUserResourceModel } from '@/modules/user/models/user-resource.model'
import { Data } from '@/modules/shared/models/data'
import { TicketAnswerCollectionModel } from '@/modules/ticket-answer/models/ticket-answer-collection.model'
import { PersonTitle } from '@/modules/common/person/models/PersonResource.model'
import { MediaResourceModel } from '@/modules/media/models/media-resource.model'

export enum TicketModelType {
  CONTENT_CAMPAIGN = 'ContentCampaign',
  CONTENT_ITEM = 'ContentItem'
}

export enum TicketStatus {
  NEW = 'new',
  PENDING_RESPONSE = 'pending_response',
  AGENT_RESPONSE = 'agent_response',
  COSTUMER_RESPONSE = 'costumer_response',
  PENDING = 'pending',
  AGENT_CREATED = 'agent_created',
  CLOSED = 'closed'
}

export interface TicketResourceModel {
  id: number,
  title: string,
  person: PersonTitle
  status: TicketStatus,
  last_answer_date: string,
  admin_note: string,
  created_at: string,
  updated_at: string,
  department: BasicDepartmentResourceModel,
  user: BasicUserResourceModel,
  answers: TicketAnswerCollectionModel[],
  ticketable_id: number | null,
  ticketable_type: string | null,
  ticketable_url: string | null,
}

export interface TicketResourceWithModel {
  statuses: { [key in TicketStatus]: string }
  model_type: string
  persons?: { [key in PersonTitle]: string } //inAgent
}

export type TicketResourceType = Data<TicketResourceModel> & TicketResourceWithModel

export interface TicketPresetModel {
  title?: string
  user_id?: number
  files?: Array<File | MediaResourceModel>
  department_id?: DepartmentIdModel
  person?: PersonTitle
  message?: string
}

